export default __webpack_public_path__ + "static/media/ViewDetailsArrow_black.b9dafb28.svg";